module.exports = __webpack_public_path__ + "img/SALA_HORNOS.f0e53645.jpg";